module.exports = __webpack_public_path__ + "img/doctorCode.8dd392b1.png";